import React from 'react';

/**
 * Icon used for loading widget
 */
const W_ICON = () => (
  <svg
    width='122'
    height='103'
    viewBox='0 0 122 103'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M86.875 73.4688L100.656 0.625H121.68L98.9688 103H77.7344L61.0703 34.5156L44.4062 103H23.1719L0.460938 0.625H21.4844L35.3359 73.3281L52.2109 0.625H70.0703L86.875 73.4688Z'
      fill='#BC00FF'
    />
  </svg>
);

export default W_ICON;
